import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-page" }
const _hoisted_2 = { class: "p-pwsetting l-container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"p-pwsetting__ttl c-ttl\"><span class=\"p-pwsetting__ttl__logo\"><img src=\"" + _imports_0 + "\" alt=\"SHUEISHA ID\"></span>新規パスワード設定</h1><div class=\"p-messages\"><div class=\"c-message\"><p class=\"c-message__txt c-message__txt--primary\"><i></i><span>英字大文字、英字小文字、数字いずれも含む8文字以上のパスワードを設定してください。</span></p></div></div>", 2)
const _hoisted_5 = { class: "p-pwsetting__field-container" }
const _hoisted_6 = { class: "p-errors" }
const _hoisted_7 = { class: "c-error" }
const _hoisted_8 = { class: "p-fields" }
const _hoisted_9 = { class: "c-field" }
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field__input" }
const _hoisted_12 = { class: "c-field" }
const _hoisted_13 = { class: "c-field__body" }
const _hoisted_14 = { class: "c-field__input" }
const _hoisted_15 = { class: "c-field has-submit has-mt" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "送信する", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "キャンセル", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Form, {
        onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.setPassword, this))),
        "validation-schema": _ctx.schema
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: _ctx.newPasswordToggle.fieldType,
                      name: "newPassword",
                      modelValue: _ctx.newPasswordRef,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPasswordRef) = $event)),
                      maxlength: _ctx.PASSWORD_MAX_LENGTH,
                      placeholder: "新しいパスワード",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 8, ["type", "modelValue", "maxlength"]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordToggle.isOn }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordToggle)))
                    }, null, 2)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPassword), 513), [
                [_vShow, errors.newPassword]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: _ctx.newPasswordRetypeToggle.fieldType,
                      name: "newPasswordRetype",
                      modelValue: _ctx.newPasswordRetypeRef,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPasswordRetypeRef) = $event)),
                      maxlength: _ctx.PASSWORD_MAX_LENGTH,
                      placeholder: "新しいパスワード確認",
                      autocomplete: "new-password",
                      required: ""
                    }, null, 8, ["type", "modelValue", "maxlength"]),
                    _createElementVNode("i", {
                      class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.newPasswordRetypeToggle.isOn }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.newPasswordRetypeToggle)))
                    }, null, 2)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newPasswordRetype), 513), [
                [_vShow, errors.newPasswordRetype]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "c-btn is-submit",
                  disabled: !meta.valid || _ctx.isDeterringRef
                }, _hoisted_18, 8, _hoisted_16),
                _createVNode(_component_router_link, {
                  to: { name: 'Login'},
                  class: _normalizeClass(["c-btn c-btn--sub", { 'is-disabled':_ctx.isDeterringRef }])
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}